import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { persistor, store } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import { createTheme, ThemeProvider } from "@mui/material";
import { SnackbarProvider } from "./Common/useSnackbar";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useThemeColor } from "./hooks/useThemeColor";
import { setEndPoint } from "./redux/action";
import { resolveEndpoint } from "./Common/utils";

// Create a client
const queryClient = new QueryClient();

const ThemedApp = () => {
  const { themeColor } = useThemeColor();
  const defaultTheme = createTheme({
    typography: {
      fontFamily: "Poppins",
    },
    palette: {
      primary: {
        main: themeColor || "#162A5C",
      },
      grey: {
        main: "#666666",
      },
    },
    components: {
      MuiTypography: {
        defaultProps: {
          color: "#5F5F5F",
        },
        styleOverrides: {},
      },
      MuiLink: {
        styleOverrides: {
          root: {
            textDecorationColor: "#5F5F5F40",
          },
        },
      },
      MuiCardActions: {
        styleOverrides: {
          root: {
            ">:not(:first-of-type)": {
              marginLeft: 0,
            },
          },
        },
      },
      MuiModal: {
        defaultProps: {
          disableScrollLock: true,
          container: typeof document !== "undefined" ? document.body : undefined,
        },
      },
      MuiPopover: {
        defaultProps: {
          container: typeof document !== "undefined" ? document.body : undefined,
        },
      },
      MuiPopper: {
        defaultProps: {
          container: typeof document !== "undefined" ? document.body : undefined,
        },
      },
      MuiStepIcon: {
        styleOverrides: {
          // text
          // active: {
          //   // "&.MuiStepIcon-text": {
          //   fill: "#FFFFFF !important",
          //   // },
          // },
          // text: {
          //   fill: "#FFFFFF !important",
          // }
        }
      },
      MuiStepLabel: {
        styleOverrides: {
          "root": {
            "&.Mui-active": {
              "& .MuiStepIcon-text": {
                "fill": "#FFFFFF !important"
              }
            }
          }
        }
      },
    },
  });
  return (
    <ThemeProvider theme={defaultTheme}>
      <SnackbarProvider>
        <App />
      </SnackbarProvider>
    </ThemeProvider>
  );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate
        persistor={persistor}
        onBeforeLift={() => {
          // After rehydrate, force hostname-based endpoint before any child mounts
          store.dispatch(setEndPoint(resolveEndpoint()));
        }}
      >
        <QueryClientProvider client={queryClient}>
          <ThemedApp />
        </QueryClientProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
